export default __webpack_public_path__ + "static/media/DataPrivacy.1f9d153a.svg";